import React, { useState } from "react";
import { Icon } from "@vds/icons";
import { Body } from "@vds/typography";

const InputStepperField = ({
  label,
  value = 10,
  unitoftime = "",
  onChange,
  minValue = 1,
  maxValue = 43201, // 30 days in minutes
  readOnly = false,
}) => {
  const [helperText, setHelperText] = useState("");
  const handleIncrement = () => {
    const numericValue = Number(value);
    if (!readOnly && numericValue < maxValue) {
      onChange(numericValue + 1);
      setHelperText(""); // Clear helper text on valid input
    } else if (!readOnly) {
      setHelperText(
        `Maximum allowed cool-down period is ${maxValue} minutes (30 Days).`
      );
    }
  };

  const handleDecrement = () => {
    const numericValue = Number(value);
    if (!readOnly && numericValue > minValue) {
      onChange(numericValue - 1);
      setHelperText("");
    } else if (!readOnly) {
      setHelperText(
        `The cool-down period must be at least ${minValue} ${unitoftime || 'minutes'}.`
      );
    }
  };

  const handleInputChange = (e) => {
    if (!readOnly) {
      const newValue = parseInt(e.target.value, 10);
      console.log({ newValue });
      if (!isNaN(newValue)) {
        if (newValue >= minValue && newValue <= maxValue) {
          onChange(newValue);
          setHelperText("");
        } else if (newValue < minValue) {
          setHelperText(
            `The cool-down period must be at least ${minValue} ${unitoftime || 'minutes'}.`
          );
        } else if (newValue > maxValue) {
          setHelperText(
            `Maximum allowed cool-down period is ${maxValue} ${unitoftime || 'minutes (30 Days)'}.`
          );
        }
      }
    }
  };

  return (
    <>
      <span style={{ color: "#000000", fontSize: "14px" }}>
        {label || "Cool down period (min.)"}
      </span>
      <div style={{ marginTop: "-10px" }}>
        <div
          style={{
            border: "1px solid #000000",
            fontSize: "14px",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "5px",
            padding: "10px",
            color: "#000000",
            borderRadius: "20px",
            width: "135px",
            height: "44px",
          }}
        >
          <span
            onClick={handleDecrement}
            style={{
              cursor: readOnly ? "not-allowed" : "pointer",
              opacity: readOnly ? 0.5 : 1,
            }}
          >
            <Icon name="minus" surface="white" size="small" color="#000000" />
          </span>
          <Body size="large" bold={true}>
            {/* <span> */}
            <input
              type="text"
              value={value}
              className="form-control"
              style={{
                color: "#000000",
                height: "20px",
                border: "0px solid #000000",
                textAlign: "center",
                backgroundColor: "transparent",
              }}
              onChange={!readOnly && handleInputChange}
              disabled={readOnly}
            />
            {/* </span> */}
          </Body>
          <span
            onClick={handleIncrement}
            style={{
              cursor: readOnly ? "not-allowed" : "pointer",
              opacity: readOnly ? 0.5 : 1,
            }}
          >
            <Icon name="plus" surface="white" size="small" color="#000000" />
          </span>
        </div>
        {helperText && (
          <div style={{ marginTop: "5px", color: "red", fontSize: "12px" }}>
            {helperText}
          </div>
        )}
      </div>
    </>
  );
};

export default InputStepperField;
